import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { URL_EMAILS } from '../constants/urls';
import LoadingSpinner from '../components/LoadingSpinner';
import EmailSuccessIcon from '../img/icons/email-success.svg';
import EmailErrorIcon from '../img/icons/email-error.svg';
import style from '../style/pages/EmailVerify.module.scss';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const EmailVerify = () => {
  const { inspectionId } = useParams();
  const [status, setStatus] = useState(STATUS.LOADING);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    if (!inspectionId || !code) {
      setErrorMessage('Return to your profile to get a new confirmation link.');
      setStatus(STATUS.ERROR);
      return;
    }

    const abortController = new AbortController();

    axios
      .put(`${URL_EMAILS}/${inspectionId}/verify`, null, {
        params: { code },
        signal: abortController.signal,
      })
      .then(() => {
        setStatus(STATUS.SUCCESS);
      })
      .catch((err) => {
        if (axios.isCancel(err)) return;
        setErrorMessage(
          'Return to your profile to get a new confirmation link.',
        );
        setStatus(STATUS.ERROR);
      });

    return () => abortController.abort();
  }, [inspectionId]);

  return (
    <div className={style.content}>
      <div className={style.card}>
        {status === STATUS.LOADING && (
          <>
            <h2 className={style.heading}>Verifying your email...</h2>
            <LoadingSpinner className={style.spinner} />
          </>
        )}
        {status === STATUS.SUCCESS && (
          <>
            <img
              alt="Email Verified"
              src={EmailSuccessIcon}
              className={style.icon}
            />
            <h2 className={style.heading}>Email confirmed</h2>
            <p className={style.errorMessage}>
              Return to the window or device you started on to continue.
            </p>
          </>
        )}
        {status === STATUS.ERROR && (
          <>
            <img
              alt="Invalid Link"
              src={EmailErrorIcon}
              className={style.icon}
            />
            <h2 className={style.heading}>Invalid link</h2>
            <p className={style.errorMessage}>{errorMessage}</p>
            <Link to="/profile" className={style.profileLink}>
              Go to profile
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailVerify;
